// Centralized RigBooks brand tokens for the web app (mirrors mobile src/theme.ts).
export const colors = {
  bg: "#0B1120",
  surface: "#162033",
  surface2: "#1E293B",
  hover: "#334155",
  accent: "#00E676",
  accentDark: "#00C853",
  accentText: "#00190A",
  blue: "#3B82F6",
  warning: "#F59E0B",
  error: "#EF4444",
  success: "#10B981",
  text: "#FFFFFF",
  dim: "#94A3B8",
  mute: "#64748B",
  border: "#1E293B",
  borderStrong: "#334155",
};

export const CATEGORY_COLORS = {
  Fuel: "#3B82F6",
  Tolls: "#F59E0B",
  Maintenance: "#EF4444",
  Food: "#10B981",
  Lodging: "#A855F7",
  Insurance: "#06B6D4",
  Other: "#94A3B8",
};

export const CATEGORIES = ["Fuel", "Tolls", "Maintenance", "Food", "Lodging", "Insurance", "Other"];

export const HAUL_STATUSES = [
  { key: "booked", label: "Booked", color: "#3B82F6" },
  { key: "in_transit", label: "In-Transit", color: "#F59E0B" },
  { key: "delivered", label: "Delivered", color: "#A855F7" },
  { key: "paid", label: "Paid", color: "#00E676" },
  { key: "canceled", label: "Canceled", color: "#64748B" },
];

export const HAUL_TYPES = ["Dry Van", "Reefer", "Flatbed", "Tanker", "Hotshot", "Other"];

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
  "VA", "WA", "WV", "WI", "WY", "DC",
];

export const AMENITY_KINDS = [
  { key: "parking", label: "Truck Parking", icon: "SquareParking" },
  { key: "fuel", label: "Fuel / Diesel", icon: "Fuel" },
  { key: "truck_stop", label: "Truck Stops", icon: "Warehouse" },
  { key: "food", label: "Food", icon: "Utensils" },
  { key: "shower", label: "Showers", icon: "ShowerHead" },
  { key: "lodging", label: "Lodging", icon: "BedDouble" },
  { key: "weigh_station", label: "Weigh Stations", icon: "Scale" },
  { key: "repair", label: "Repair", icon: "Wrench" },
];

export function fmtMoney(n) {
  if (n == null || isNaN(n)) return "$0";
  const abs = Math.abs(n);
  const s =
    abs >= 1000
      ? `$${(Math.round(abs * 100) / 100).toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })}`
      : `$${abs.toFixed(2)}`;
  return n < 0 ? `-${s}` : s;
}

export function rpmColor(rpm) {
  if (rpm >= 2.5) return colors.accent;
  if (rpm >= 2.0) return colors.success;
  if (rpm >= 1.5) return colors.warning;
  return colors.error;
}

// IRS 2026 business standard mileage rate
export const IRS_MILEAGE_RATE = 0.67;
